import React from "react";

import { ReferenceInput, AutocompleteInput } from "react-admin";
import SearchInput from "../common/SearchInput";

const mailAccountFilters = [
  <SearchInput
    label="common.search"
    source="q"
    alwaysOn
    resettable
    autoFocus
  />,
  <ReferenceInput
    source="customerId"
    reference="Customer"
    sort={{ field: "name", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
    alwaysOn
  >
    <AutocompleteInput optionText="name" emptyText="- alle -" />
  </ReferenceInput>,
  <ReferenceInput
    source="domainId"
    reference="Domain"
    sort={{ field: "unicodeName", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
  >
    <AutocompleteInput optionText="unicodeName" />
  </ReferenceInput>,
];
export default mailAccountFilters;
